import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/organization-types/profile/loading';

export const Route = createFileRoute('/_private/settings/organization-types/$id')({
  pendingComponent: Loading,
});
